import { ROLE_RANK } from "./roles";
export const NAV = [
    { title: "POS", titleKey: "nav.till", role: "cashier", items: [
            { id: "pos", icon: "shopping-cart", label: "POS", labelKey: "navItem.pos" },
            { id: "held", icon: "pause", label: "Held Bills", labelKey: "navItem.held" },
            { id: "recent", icon: "receipt", label: "Recent Sales", labelKey: "navItem.recent" },
            { id: "quotes", icon: "file-text", label: "Quotations", labelKey: "navItem.quotes" },
            { id: "shift", icon: "calendar-clock", label: "Shift", labelKey: "navItem.shift" },
            { id: "till-settings", icon: "sliders-horizontal", label: "Settings", labelKey: "navItem.tillSettings" },
        ] },
    { title: "Overview", titleKey: "nav.overview", role: "manager", items: [
            { id: "dashboard", icon: "layout-dashboard", label: "Dashboard", labelKey: "navItem.dashboard" },
        ] },
    { title: "Sales & Money", titleKey: "nav.salesMoney", role: "manager", items: [
            { id: "sales", icon: "receipt", label: "Sales History", labelKey: "navItem.sales" },
            { id: "conflicts", icon: "shield-alert", label: "Sale Reviews", labelKey: "navItem.conflicts" },
            { id: "shifts", icon: "calendar-days", label: "Shifts & Drawers", labelKey: "navItem.shifts" },
            { id: "expenses", icon: "wallet", label: "Expenses", labelKey: "navItem.expenses" },
            { id: "sync-queue", icon: "database", label: "Sync Queue", labelKey: "navItem.syncQueue" },
        ] },
    { title: "Catalog", titleKey: "nav.catalog", role: "manager", items: [
            { id: "products", icon: "package", label: "Products", labelKey: "navItem.products" },
            { id: "bulk-import", icon: "upload", label: "Bulk Import", labelKey: "navItem.bulkImport" },
            { id: "add-many", icon: "table", label: "Add Multiple Products", labelKey: "navItem.addMany" },
            { id: "catbrand", icon: "folder-tree", label: "Categories & Brands", labelKey: "navItem.catbrand" },
            { id: "promotions", icon: "percent", label: "Promotions", labelKey: "navItem.promotions" },
            { id: "customers", icon: "users", label: "Customers", labelKey: "navItem.customers" },
            { id: "suppliers", icon: "truck", label: "Suppliers", labelKey: "navItem.suppliers" },
        ] },
    { title: "Inventory", titleKey: "nav.inventory", role: "manager", items: [
            { id: "stock", icon: "boxes", label: "Stock by Store", labelKey: "navItem.stock" },
            { id: "receive", icon: "package-plus", label: "Receive Goods", labelKey: "navItem.receive" },
            { id: "movements", icon: "arrow-left-right", label: "Stock Movements", labelKey: "navItem.movements" },
            { id: "transfers", icon: "truck", label: "Transfers", labelKey: "navItem.transfers" },
            { id: "count", icon: "clipboard-list", label: "Stock Count", labelKey: "navItem.count" },
        ] },
    { title: "Admin", titleKey: "nav.admin", role: "manager", items: [
            { id: "staff", icon: "user-cog", label: "Staff", labelKey: "navItem.staff" },
            { id: "stores", icon: "store", label: "Stores", labelKey: "navItem.stores" },
            { id: "reports", icon: "bar-chart-3", label: "Reports", labelKey: "navItem.reports" },
            { id: "settings", icon: "settings", label: "Global Settings", labelKey: "navItem.settings" },
            { id: "audit", icon: "scroll-text", label: "Audit Log", labelKey: "navItem.audit" },
        ] },
];
export const canSee = (pageId, role) => {
    const section = NAV.find((s) => s.items.some((i) => i.id === pageId));
    if (!section)
        return false;
    return ROLE_RANK[role] >= ROLE_RANK[section.role];
};
//# sourceMappingURL=nav.js.map